// setup DOM
let canStyleEl = document.createElement('style')
canStyleEl.innerHTML = '[x-can] { display: none; }'

let canLinkEl = document.createElement('link')
canLinkEl.setAttribute('rel', 'stylesheet')

document.head.append(canStyleEl, canLinkEl)

let canTimeoutId: any = null
const permissions = new Set()

export function canDirective(_: unknown, { expression }: { expression: string }) {
  if (permissions.has(expression)) return
  permissions.add(expression)

  if (canTimeoutId) return
  // wait 1 tick to collect all permissions needed
  canTimeoutId = setTimeout(() => {
    canTimeoutId = null
    canLinkEl.setAttribute('href', `/_uplandjs/can.css?p=${[...permissions.values()].join(',')}`)
  }, 0)
}
